import Axios from 'axios'
import AES from './../common/aes'
export default {
  // 登录
  /**
   * 全国 0 1
   * 校级 2
   * 备课 3
   */
  async login(formData) {
    const { data } = await Axios.post(`/api/v1/euc/auth/login`, formData)
    return data
  },
  // 全国平台登录
  // 机构管理
  async login01(formData) {
    const { data } = await Axios.post(
      `/api/v1/euc/auth/org_admin/login`,
      formData
    )
    return data
  },
  // 系统管理
  async login0(formData) {
    const { data } = await Axios.post(
      `/api/v1/euc/auth/sys_admin/login`,
      formData
    )
    return data
  },
  // 校级平台登录
  async login2(formData) {
    const { data } = await Axios.post(
      `/api/v1/euc/auth/school_admin/login`,
      formData
    )
    return data
  },
  // 备课端登录
  async login3({ username, pwd }) {
    let sha512 = require('js-sha512').sha512
    const password = sha512(pwd)
    const { data } = await Axios.post(
      `/api/v1/euc/auth/teacher/login?username=${username}&password=${password}`
    )
    return data
  }
}
